module.exports = __webpack_public_path__ + "static/img/txt-logosoeji.8b11561.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/txt-logosoeji.svg
// module id = /4ci
// module chunks = 1